import gql from 'graphql-tag';
export const matchPlayerFragment = gql `
  fragment MatchPlayer on MatchPlayer {
    id
    team {
      id
    }
    position
    number
    starting
    playing
    captain
    redCard
    photo {
      id
      url
    }
    player {
      id
      firstName
      lastName
    }
  }
`;
//# sourceMappingURL=matchPlayer.js.map